import React, { PureComponent, PropTypes } from 'react';

import LegendTopRange from './LegendTopRange';

import './legend-top.scss';

class LegendTop extends PureComponent {

  render() {
    const legendTopRanges = this.props.ranges.map((range, rangeIndex) =>
      <LegendTopRange
        key={`legendtop_range_${rangeIndex}`}
        scale_label={range.scale_label}
        from={range.from}
        to={range.to}
        scale_icon={range.scale_icon}
        items={range.items}
      />);

    return (
      <div className="mt-toplegend-wrapper desk-ph+">
        {legendTopRanges}
        <div className="clearfix" />
      </div>
    );
  }
}

LegendTop.defaultProps = {
  ranges: [],
};

LegendTop.propTypes = {
  ranges: PropTypes.array,
};

export default LegendTop;



/** WEBPACK FOOTER **
 ** ./apps/maptool/components/LegendTop/index.js
 **/